import _regeneratorRuntime from '@babel/runtime/regenerator';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import cloudinary from 'cloudinary-core';
import { useInView } from 'react-intersection-observer';
import useNativeLazyLoading from '@charlietango/use-native-lazy-loading';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import fetch from 'isomorphic-unfetch';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useImage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      cloudName = _ref.cloudName;

  var cld = cloudinary.Cloudinary["new"]({
    cloud_name: cloudName
  }, {
    secure: true
  });
  var supportsLazyLoading = useNativeLazyLoading();

  var _useInView = useInView({
    triggerOnce: true
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1]; // Need a better checking solution
  // if (!cloudName) {
  //   throw new Error("Please enter a valid cloud name")
  // }


  function blurredPlaceholderUrl(_ref2) {
    var publicId = _ref2.publicId,
        width = _ref2.width,
        height = _ref2.height;

    if (!width && !height) {
      return "https://res.cloudinary.com/".concat(cloudName, "/image/upload/e_blur:1000,q_1,f_auto/").concat(publicId, ".jpg");
    } else if (!height) {
      return "https://res.cloudinary.com/".concat(cloudName, "/image/upload/c_scale,w_").concat(width, "/e_blur:1000,q_1,f_auto/").concat(publicId, ".jpg");
    } else if (!width) {
      return "https://res.cloudinary.com/".concat(cloudName, "/image/upload/c_scale,e_blur:1000,q_1,f_auto/h_").concat(height, "/").concat(publicId, ".jpg");
    } else {
      return "https://res.cloudinary.com/".concat(cloudName, "/image/upload/w_").concat(width, "/c_scale,e_blur:1000,q_1,f_auto/h_").concat(height, "/").concat(publicId, ".jpg");
    }
  }

  var _React$useState = useState({
    public_id: '',
    transform_options: {}
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      imageOptions = _React$useState2[0],
      setImageOptions = _React$useState2[1];

  var _useQuery = useQuery(["".concat(imageOptions.public_id, "-url"), imageOptions], /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, imageOptions) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return cld.url(imageOptions.publicId, _objectSpread({}, imageOptions.transformations));

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(), {
    enabled: imageOptions
  }),
      url = _useQuery.data,
      isLoading = _useQuery.isLoading,
      isError = _useQuery.isError,
      isIdle = _useQuery.isIdle,
      isSuccess = _useQuery.isSuccess,
      error = _useQuery.error;

  function generateUrl() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        publicId = _ref4.publicId,
        _ref4$transformations = _ref4.transformations,
        transformations = _ref4$transformations === void 0 ? {} : _ref4$transformations;

    if (!publicId) {
      throw new Error("Must provide a public id of your asset");
    } // Attach { crop: 'scale' } automatically when height or width options are supplied. This is to handle applying those transformations properly


    if (transformations.hasOwnProperty('width') || transformations.hasOwnProperty('height') && !transformations.hasOwnProperty('crop')) {
      transformations.crop = 'scale';
    } // Attach { fetchFormat: 'auto' } automatically when no config is supplied. This will deliver the best image format automatically depending on your browser


    if (!transformations.hasOwnProperty('fetchFormat')) {
      transformations.fetchFormat = 'auto';
    } // Attach { quality: 'auto' } automatically when no config is supplied


    if (!transformations.hasOwnProperty('quality')) {
      transformations.quality = 'auto';
    }

    return setImageOptions({
      publicId: publicId,
      transformations: transformations
    });
  }

  return {
    generateUrl: generateUrl,
    blurredPlaceholderUrl: blurredPlaceholderUrl,
    url: url,
    isLoading: isLoading,
    isError: isError,
    isIdle: isIdle,
    isSuccess: isSuccess,
    error: error,
    ref: ref,
    inView: inView,
    supportsLazyLoading: supportsLazyLoading
  };
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useUpload() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      endpoint = _ref.endpoint;

  var type = arguments.length > 1 ? arguments[1] : undefined;

  if (!endpoint) {
    throw new Error("Must provide an endpoint to upload");
  }

  var _useMutation = useMutation( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var file, uploadOptions, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              file = _ref2.file, uploadOptions = _ref2.uploadOptions;

              if (type) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return fetch(endpoint, {
                method: 'POST',
                body: JSON.stringify(_objectSpread$1({
                  eager: uploadOptions.eager || {},
                  tags: _toConsumableArray(uploadOptions.tags),
                  public_id: uploadOptions.public_id,
                  uploadPreset: uploadOptions.uploadPreset || "",
                  file: file
                }, uploadOptions))
              });

            case 4:
              res = _context.sent;
              _context.next = 10;
              break;

            case 7:
              _context.next = 9;
              return fetch(endpoint, {
                method: 'POST',
                body: JSON.stringify(_objectSpread$1({
                  eager: uploadOptions.eager || {},
                  tags: _toConsumableArray(uploadOptions.tags),
                  public_id: uploadOptions.public_id,
                  type: type,
                  uploadPreset: uploadOptions.uploadPreset || "",
                  file: file
                }, uploadOptions))
              });

            case 9:
              res = _context.sent;

            case 10:
              return _context.abrupt("return", res.json());

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      upload = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      data = _useMutation2$.data,
      isIdle = _useMutation2$.isIdle,
      isSuccess = _useMutation2$.isSuccess,
      isLoading = _useMutation2$.isLoading,
      isError = _useMutation2$.isError,
      error = _useMutation2$.error;

  return {
    upload: upload,
    data: data,
    isIdle: isIdle,
    isSuccess: isSuccess,
    isLoading: isLoading,
    isError: isError,
    error: error
  };
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useVideo(_ref) {
  var cloudName = _ref.cloudName;
  var cld = cloudinary.Cloudinary["new"]({
    cloud_name: cloudName
  }, {
    secure: true
  });

  if (!cloudName) {
    throw new Error("Please enter a valid cloud name");
  }

  var _React$useState = useState({
    publicId: '',
    transformations: {}
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      videoOptions = _React$useState2[0],
      setVideoOptions = _React$useState2[1];

  var _useQuery = useQuery(["".concat(videoOptions.publicId, "-url"), videoOptions], /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, videoOptions) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return cld.video_url(videoOptions.publicId, _objectSpread$2({}, videoOptions.transformations));

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), {
    enabled: videoOptions
  }),
      url = _useQuery.data,
      isIdle = _useQuery.isIdle,
      isSuccess = _useQuery.isSuccess,
      isLoading = _useQuery.isLoading,
      isError = _useQuery.isError,
      error = _useQuery.error;

  function generateUrl() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        publicId = _ref3.publicId,
        _ref3$transformations = _ref3.transformations,
        transformations = _ref3$transformations === void 0 ? {} : _ref3$transformations;

    if (!publicId) {
      throw new Error("Must provide a public id of your asset");
    } // Attach { crop: 'scale' } automatically when height or width options are supplied. This is to handle applying those transformations properly


    if ((transformations.hasOwnProperty('width') || transformations.hasOwnProperty('height')) && !transformations.hasOwnProperty('crop')) {
      transformations.crop = 'scale';
    } // Attach { fetchFormat: 'auto' } automatically when no config is supplied. This will deliver the best image format automatically depending on your browser


    if (!transformations.hasOwnProperty('fetchFormat')) {
      transformations.fetchFormat = 'auto';
    } // Attach { quality: 'auto' } automatically when no config is supplied


    if (!transformations.hasOwnProperty('quality')) {
      transformations.quality = 'auto';
    }

    return setVideoOptions({
      publicId: publicId,
      transformations: transformations
    });
  }

  return {
    generateUrl: generateUrl,
    url: url,
    isIdle: isIdle,
    isSuccess: isSuccess,
    isLoading: isLoading,
    isError: isError,
    error: error
  };
}

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useGif(_ref) {
  var cloudName = _ref.cloudName;
  var cld = cloudinary.Cloudinary["new"]({
    cloud_name: cloudName
  }, {
    secure: true
  });

  var _React$useState = useState({
    publicId: '',
    transformations: {}
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      gifOptions = _React$useState2[0],
      setGifOptions = _React$useState2[1];

  var _useQuery = useQuery(["".concat(gifOptions.publicId, "-url"), gifOptions], /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, gifOptions) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return cld.video_url("".concat(gifOptions.publicId, ".gif"), _objectSpread$3(_objectSpread$3({}, gifOptions.transformations), {}, {
                flags: "animated",
                effect: "loop"
              }));

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), {
    enabled: gifOptions
  }),
      url = _useQuery.data,
      isLoading = _useQuery.isLoading,
      isError = _useQuery.isError,
      isSuccess = _useQuery.isSuccess,
      isIdle = _useQuery.isIdle,
      error = _useQuery.error;

  function generateUrl() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        publicId = _ref3.publicId,
        _ref3$transformations = _ref3.transformations,
        transformations = _ref3$transformations === void 0 ? {} : _ref3$transformations;

    if (!publicId) {
      throw new Error("Must provide a public id of your asset");
    } // Attach { crop: 'scale' } automatically when height or width options are supplied. This is to handle applying those transformations properly


    if ((transformations.hasOwnProperty('width') || transformations.hasOwnProperty('height')) && !transformations.hasOwnProperty('crop')) {
      transformations.crop = 'scale';
    } // Attach { fetchFormat: 'auto' } automatically when no config is supplied. This will deliver the proper gif format automatically depending on your browser


    if (!transformations.hasOwnProperty('fetchFormat')) {
      transformations.fetchFormat = 'auto';
    }

    return setGifOptions({
      publicId: publicId,
      transformations: transformations
    });
  }

  return {
    generateUrl: generateUrl,
    url: url,
    isLoading: isLoading,
    isError: isError,
    isIdle: isIdle,
    isSuccess: isSuccess,
    error: error
  };
}

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useSearch() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      endpoint = _ref.endpoint;

  if (!endpoint) {
    throw new Error("Must provide an endpoint to search");
  }

  var expressionConfig = "";
  /*
      search by: 
        - public ID by name or by prefix --> folder/imagePublicId | publicId | (prefix search w/) publicId*
        - resource type --> can only be image or video (strictly)
        - folder --> (returns an exact folder..no subfolders) test/sample | (any path that contains "sample") sample
        - tags --> (space your tags out) "each word is a different tag" 
        - aspect ratio --> (string of your aspect ratio) "16:9"
       To do this, we'll need to check for the key, and crate a template string
      that we can send and place directly inside of our backend search query 
       --> search expects a structure like so `expression: 'resource_type:image AND tags="whatever tags you have"'
       you can now call search from the client structured like this --> needs at least one of the following, but can include all/multiple
       search({
        publicId: "your-public-id"
        resourceType: "image || video"
        folder: "test/sample"
        tags: "tag1 tag2"
        aspectRatio: "16:9"
      })
       OR you can still pass a full string to expression key:
       search({ expression: "public_id=your-public-id AND aspect_ratio:16:9" })
  */

  var _useMutation = useMutation( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(searchConfig) {
      var res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              /* 
                The below searchConfig checks will allow you to use an opinionated (and growing) search w/ object configuration
                If you want to make more granular search decisions, pass the `expression` key and provide the typical Cloudinary search expression string
              */
              if (searchConfig.hasOwnProperty('publicId')) {
                if (expressionConfig.trim().length === 0) {
                  expressionConfig = "public_id".concat(searchConfig.publicId);
                } else {
                  expressionConfig + " AND public_id".concat(searchConfig.publicId);
                }
              }

              if (searchConfig.hasOwnProperty('resourceType')) {
                if (expressionConfig.trim().length === 0) {
                  expressionConfig = "resource_type=".concat(searchConfig.resourceType);
                } else {
                  expressionConfig + " AND resource_type=".concat(searchConfig.resourceType);
                }
              }

              if (searchConfig.hasOwnProperty('folder')) {
                if (expressionConfig.trim().length === 0) {
                  expressionConfig = "folder=".concat(searchConfig.folder);
                } else {
                  expressionConfig + " AND folder=".concat(searchConfig.folder);
                }
              }

              if (searchConfig.hasOwnProperty('tags')) {
                if (expressionConfig.trim().length === 0) {
                  expressionConfig = "tags=".concat(searchConfig.tags);
                } else {
                  expressionConfig + " AND tags=".concat(searchConfig.tags);
                }
              }

              if (searchConfig.hasOwnProperty('aspectRatio')) {
                if (expressionConfig.trim().length === 0) {
                  expressionConfig = "aspect_ratio=\"".concat(searchConfig.aspectRatio, "\"");
                } else {
                  expressionConfig + " AND aspect_ratio=\"".concat(searchConfig.aspectRatio, "\"");
                }
              }

              if (searchConfig.hasOwnProperty('config')) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", searchConfigs.config = {});

            case 7:
              // this will allow you to pass in your own configured search expression for granular control
              if (expressionConfig.trim().length === 0) {
                expressionConfig = searchConfig;
              }

              _context.next = 10;
              return fetch(endpoint, {
                method: "POST",
                body: JSON.stringify(_objectSpread$4({
                  expression: expressionConfig
                }, searchConfig.config))
              });

            case 10:
              res = _context.sent;
              return _context.abrupt("return", res.json());

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }()),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      search = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      data = _useMutation2$.data,
      isLoading = _useMutation2$.isLoading,
      isError = _useMutation2$.isError,
      isIdle = _useMutation2$.isIdle,
      isSuccess = _useMutation2$.isSuccess,
      error = _useMutation2$.error;

  return {
    search: search,
    data: data,
    isLoading: isLoading,
    isError: isError,
    isIdle: isIdle,
    isSuccess: isSuccess,
    error: error
  };
}

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useAudio(_ref) {
  var cloudName = _ref.cloudName;
  var cld = cloudinary.Cloudinary["new"]({
    cloud_name: cloudName
  }, {
    secure: true
  });

  var _React$useState = useState({
    publicId: '',
    transformations: {}
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      audioOptions = _React$useState2[0],
      setAudioOptions = _React$useState2[1];

  var _useQuery = useQuery(["".concat(audioOptions.publicId, "-url"), audioOptions], /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, audioOptions) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return cld.video_url("".concat(audioOptions.publicId, ".mp3"), _objectSpread$5({}, audioOptions.transformations));

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), {
    enabled: audioOptions
  }),
      url = _useQuery.data,
      isLoading = _useQuery.isLoading,
      isError = _useQuery.isError,
      isSuccess = _useQuery.isSuccess,
      isIdle = _useQuery.isIdle,
      error = _useQuery.error;

  function generateUrl() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        publicId = _ref3.publicId,
        _ref3$transformations = _ref3.transformations,
        transformations = _ref3$transformations === void 0 ? {} : _ref3$transformations;

    if (!publicId) {
      throw new Error("Must provide a public id of your asset");
    }

    return setAudioOptions({
      publicId: publicId,
      transformations: transformations
    });
  }

  return {
    generateUrl: generateUrl,
    url: url,
    isLoading: isLoading,
    isError: isError,
    isSuccess: isSuccess,
    isIdle: isIdle,
    error: error
  };
}

function useCloudinary() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      cloud_name = _ref.cloud_name;

  var cld = cloudinary.Cloudinary["new"]({
    cloud_name: cloud_name
  }, {
    secure: true
  });
  return {
    cld: cld,
    cloudinaryCore: cloudinary
  };
}

export { useAudio, useCloudinary, useGif, useImage, useSearch, useUpload, useVideo };